module.exports = __webpack_public_path__ + "static/img/whiteribbon.2ae75a1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/whiteribbon.png
// module id = 342
// module chunks = 0